import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GetLevelOneApi } from "../LevelOne/LevelOneAction";
import { AddLevelTwoApi } from "./LevelTwoAction";
import { setHeading } from "../../../accounts/account.actions";
import _ from "lodash";
import Select from 'react-select';
import Swal from 'sweetalert';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import { GlobalSpinner } from "../../../../../global/globalFunctions";


const AddLevelTwo = (props) => {
    const [levelOneId, setLevelOneId] = useState();
    const [levelOneName, setLevelOneName] = useState();
    const [levelTwoName, setLevelTwoName] = useState();
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    function SaveLevelTwo() {
        props.AddLevelTwoApi({
            levelOneId: levelOneId,
            levelOneName: levelOneName,
            levelTwoName: levelTwoName,
        },
            handleVisible,
            handleDangerVisible
        );
        setLevelOneId("")
        setLevelTwoName("")
    }
    const handleVisible = (msg) => {
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    }
    const handleDangerVisible = (error) => {
        setDangerVisibleAlert(true)
        setTimeout(() => {
            setDangerVisibleAlert(false)
        }, 9000);
        Swal({
            title: "Error",
            text: error,
            icon: "error",
            button: "Ok",
        });
    }

    const handleChangeLevelOne = (selectedOption) => {
        setLevelOneId(selectedOption.value);
        setLevelOneName(selectedOption.label);
    };
    const getLevelOneList = !_.isEmpty(props.levelOneList) && props.levelOneList.data.map((x) => {
        let data = { value: x._id, label: `${x.key} - ${x.name}` };
        return data;
    });

    useEffect(() => {
        props.GetLevelOneApi();
        props.setHeading("Add Level Two");
    }, []);

    return (
        <>
            {props.isFetchingLevelOne || props.isAddingLevelTwo ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label><b> Select Level 1 *</b></Form.Label>
                                <Select
                                    placeholder="Select Level 1"
                                    onChange={handleChangeLevelOne}
                                    options={getLevelOneList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Level 2 Name *</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Level 2 Name"
                                    onChange={(e) => setLevelTwoName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(levelOneId) || _.isEmpty(levelTwoName) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveLevelTwo}> SAVE </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetLevelOneApi: () => dispatch(GetLevelOneApi()),
        setHeading: (data) => dispatch(setHeading(data)),
        AddLevelTwoApi: (data, handleVisible, handleDangerVisible) => dispatch(AddLevelTwoApi(data, handleVisible, handleDangerVisible)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingLevelTwo: state.LevelTwoReducer.isAddingLevelTwo,
    isFetchingLevelOne: state.LevelOneReducer.isFetchingLevelOne,
    levelOneList: state.LevelOneReducer.levelOneList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddLevelTwo);